export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7712.b2f3f8d3.jpg";